import React from 'react';
import { Icon } from 'antd';

import formatPrice from '~helpers/currency';

import Card from '../card';

export default function ProductInfo({
  t,
  productInfo = {},
  showExtra = false,
  setVisibleModal = () => {},
}) {
  const productInfoFields = [
    {
      label: t('cms.special_offer.map.modal.property_selector.title'),
      value: productInfo?.propertyName,
    },
    {
      label: t('cms.reconciliation.lead_generation.update.modal.room'),
      value: productInfo?.unitTypeName,
    },
    {
      label: t('cms.reconciliation.lead_generation.update.modal.listing_price'),
      value: productInfo?.listingSalesPrice
        ? formatPrice(productInfo.listingSalesPrice, productInfo?.currency)
        : '-',
    },
  ];

  return (
    <Card
      id="product_info"
      title={t('cms.reconciliation.lead_generation.detail.product_info.title')}
      dataSet={productInfoFields}
      extra={
        showExtra && (
          <Icon onClick={() => setVisibleModal(true)} type="edit" style={{ color: '#38b2a6' }} />
        )
      }
    />
  );
}
